import { useRef, useCallback } from 'react';

/**
 * Focuses an element as soon as it's mounted on the DOM
 *
 * @example
 * const MyComponent = () => {
 *   const autoFocus = useAutoFocus();
 *   return (
 *     <button ref={autoFocus} />
 *   );
 * }
 */
export default function useAutoFocus() {
  const hasFocused = useRef();
  const focusElement = useCallback(element => {
    if (element && !hasFocused.current) {
      element.focus();
    }
  }, []);
  return focusElement;
}
